<template>
  <div class="home page">
    <div class="columns is-mobile">
      <div class="column">
        <h1 class="title is-4">Administration</h1>
      </div>
      <div class="column has-text-right">
        <!-- <button class="button" @click="$router.push({path:'admin-settings'})">
          Settings&nbsp;<i class="fas fa-cog"></i>
        </button> -->
      </div>
    </div>

    <div class="columns">
      <div class="column is-3" v-for="item of items" :key="item.name">
        <button class="button is-large home-button" @click="$router.push({path: item.to})">
          <i class="fa-lg" :class="[item.icon]"></i>&nbsp;{{ item.name}}
        </button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'AdminHome',
  computed: {
    user () { return this.$store.getters.user },
    pages () { return this.$store.getters.pages },
    items () {
      if (!this.user) {
        return []
      }
      let items = []
      for (let item of this.pages) {
        if (item.to === '/admin') continue
        if (item.privilege !== 'admin') continue
        if (this.user.privileges.indexOf(item.privilege) >= 0) {
          items.push(item)
        }
      }
      return items
    }
  }
}
</script>

<style>
.home-button {
  width: 100%;
}
</style>
